import React, { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';

import { Outlet } from 'react-router-dom';
import IdleTimerContainer from './IdleTimerContainer';

export const LayoutRoute = ({alert, businessUnit}) => (
  <>
    <NavMenu alert={alert} businessUnit={businessUnit} />
    <Layout>
      <Outlet />
    </Layout>
    <IdleTimerContainer />
  </>
);

export const Layout = (props) => {
  useEffect(() => {
    Layout.displayName = Layout.name;
  }, [])

  return (
    <div>
      <Container>
        {props.children}
      </Container>
      <ToastContainer
              position="bottom-right"
              autoClose={2000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable={false}
              pauseOnHover
            />
    </div>
  );
}

// export class Layout extends Component {
//   static displayName = Layout.name;

//   render() {
//     return (
//       <div>
//         <NavMenu />
//         <Container>
//           {this.props.children}
//         </Container>
//       </div>
//     );
//   }
// }
